import { isAllowedPaletteGroup, isAllowedPalettePath } from './catalogConfig';
import { PaletteItem, PaletteRecentEntry } from './types';

const RECENT_KEY = 'global-palette.recent';
const MAX_RECENT = 15;

function readEntries(): PaletteRecentEntry[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((entry) => entry && typeof entry.id === 'string' && typeof entry.kind === 'string');
  } catch {
    return [];
  }
}

function isAllowedRecent(entry: PaletteRecentEntry): boolean {
  if (entry.kind === 'website' || entry.kind === 'server' || entry.kind === 'console') {
    return true;
  }
  if (entry.kind === 'page') {
    const groupPath = entry.meta && entry.meta.groupPath;
    if (typeof groupPath === 'string' && isAllowedPaletteGroup(String(groupPath))) {
      return true;
    }
    return isAllowedPalettePath(entry.path);
  }
  return false;
}

export function loadRecentJumps(): PaletteRecentEntry[] {
  return readEntries().filter(isAllowedRecent).slice(0, MAX_RECENT);
}

export function pushRecentJump(item: PaletteItem): void {
  const kind = item.kind === 'recent' ? 'page' : item.kind;
  const next: PaletteRecentEntry = {
    id: item.id,
    kind: kind as PaletteRecentEntry['kind'],
    label: item.label,
    description: item.description,
    icon: item.icon,
    path: item.path,
    routeName: item.routeName,
    routeParams: item.routeParams,
    routeQuery: item.routeQuery,
    meta: item.meta,
    at: Date.now(),
  };

  if (!isAllowedRecent(next)) {
    return;
  }

  const existing = readEntries().filter((entry) => entry.id !== next.id);
  const merged = [next, ...existing].filter(isAllowedRecent).slice(0, MAX_RECENT);

  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(merged));
  } catch {
    // ignore quota / private mode
  }
}

export function clearRecentJumps(): void {
  try {
    localStorage.removeItem(RECENT_KEY);
  } catch {
    // ignore
  }
}

export function recentToPaletteItems(entries: PaletteRecentEntry[]): PaletteItem[] {
  return entries.map((entry) => ({
    id: `recent:${entry.id}`,
    kind: 'recent',
    label: entry.label,
    description: entry.description,
    icon: entry.icon || 'mdi-history',
    path: entry.path,
    routeName: entry.routeName,
    routeParams: entry.routeParams,
    routeQuery: entry.routeQuery,
    meta: {
      ...entry.meta,
      sourceKind: entry.kind,
      at: entry.at,
    },
  }));
}
